window.addEventListener("DOMContentLoaded", (event) => {
    if ((window.document as any).documentMode) {
        let hero : any = document.querySelector('.hero__right');
        let contentHeight : Number = (document as any).querySelector('.hero').clientHeight;
        hero.style.height = `${contentHeight}px`;
      }
});
